import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

const FOOTER_LINKS = [
  {
    title: 'Discord',
    url: 'https://discord.com/invite/ZduXSdd',
    icon: '/img/footer/discord.png',
  },
  {
    title: 'Telegram',
    url: 'https://t.me/surf_finance',
    icon: '/img/footer/telegram.png',
  },
  {
    title: 'Twitter',
    url: 'https://twitter.com/surf_defi',
    icon: '/img/footer/twitter.png',
  },
  {
    title: 'Reddit',
    url: 'https://www.reddit.com/r/SurfFinance',
    icon: '/img/footer/reddit.png',
  },
  {
    title: 'Medium',
    url: 'https://surf-finance.medium.com',
    icon: '/img/footer/medium.png',
  },
  {
    title: 'GitHub',
    url: 'https://github.com/SURF-Finance',
    icon: '/img/footer/github.png',
  },
];

const renderFooterLinks = () =>
  FOOTER_LINKS.map(({ title, url, icon }) => (
    <a
      key={title}
      href={url}
      title={title}
      className="block w-12 h-12 mx-auto md:m-0"
      target="_blank"
      rel="noreferrer noopener"
    >
      <img src={icon} alt={title} />
    </a>
  ));

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="p-6 mt-16 font-josefin-sans text-center bg-eth-dark text-white">
      <div className="container space-y-6">
        <img src="/img/footer/logo.svg" className="w-20 h-20 mx-auto -mt-16" alt="" />
        <span className="block pb-4 uppercase text-xl tracking-extra-wide">
          <Trans i18nKey="footer.title">
            Backed by the <strong>SURF.Finance</strong> ecosystem
          </Trans>
        </span>
        <span className="block uppercase text-blue-footer border-t border-blue-footer">
          <span className="relative -top-3 px-4 bg-eth-dark">{t('footer.social')}</span>
        </span>
        <div className="md:hidden grid grid-cols-3 gap-y-4">{renderFooterLinks()}</div>
        <div className="hidden md:flex justify-center space-x-16 pb-4">{renderFooterLinks()}</div>
      </div>
    </footer>
  );
};

export default Footer;
